import * as React from 'react';
import { flow, get, forEach } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, Form, FormGroup, Row} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {IChannel, IProduct, QuoteStatus} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import Vehicles from './components/Vehicles';
import VehiclesQuote from '../Quote/components/Vehicles';
import FieldFormControl from '../../../../components/FieldFormControl';
import FaCheck from 'react-icons/fa/check';
import {isRequired} from '../../../../util/validators';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import {getReferralsAndDeclines} from '../../../../util/helpers';
import {isUndefined} from 'util';

interface IVehiclesFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };
  vehicleCount: number;
  vehicles: any;
  customerType: string;
}

class VehiclesForm extends React.Component<IVehiclesFormProps> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    referred: false,
    duplicateRegistration: -1,
  };

  public componentWillReceiveProps(nextProps) {
    const { quote, actions, vehicles } = this.props;

    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (this.state.declines !== referralsAndDeclines.declines) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (this.state.referrals !== referralsAndDeclines.referrals) {
      this.setState({referrals: referralsAndDeclines.referrals});
      if (!referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
        this.setState({referred: true});
        setTimeout((() => {
          actions.quote.referralQuote(quote.application.id, referralsAndDeclines.referrals);
        }), 2000);
      }
    }
    if (this.state.errors !== referralsAndDeclines.errors) {
      this.setState({ errors: referralsAndDeclines.errors });
    }

    if (vehicles !== nextProps.vehicles) {
      const registrationList = [];
      this.setState({duplicateRegistration: -1});
      forEach(nextProps.vehicles, (vehicle, index) => {
        if (vehicle.registrationNumber && registrationList.includes(vehicle.registrationNumber)) {
          this.setState({duplicateRegistration: index});
        }
        registrationList.push(vehicle.registrationNumber);
      });
    }
  }

  // private checkVehicles(vehicles) {
  //   if (isUndefined(vehicles)) {
  //     return false;
  //   }
  //
  //   return vehicles.reduce((carry, vehicle) => {
  //     return carry && vehicle.bodyType && vehicle.year && vehicle.value;
  //   }, true);
  // }
  //
  // private checkVehiclesInfo(vehicles) {
  //   if (isUndefined(vehicles)) {
  //     return false;
  //   }
  //
  //   return vehicles.reduce((carry, vehicle) => {
  //     return carry && vehicle.model;
  //   }, true);
  // }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
          channel={this.props.channel}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/proposer'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private weightOptions() {
    const { quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.weight_types', {});

    return Object.keys(types).map((type) => {
      return { label: type, value: type };
    });
  }

  private coverOptions() {
    const { quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.cover_types.horseboxes', {});

    return Object.values(types).map((type) => {
      return { label: type, value: type };
    });
  }

  private drivingRestrictionOptions() {
    const { customerType, quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.driving_restrictions', {});

    const limitedTypes = [];
    const disallowed = ['Any driver'];
    if (customerType === 'joint' || customerType === 'company') {
      disallowed.push('Insured only');
      disallowed.push('Insured and Spouse');
      disallowed.push('Insured and named');
      disallowed.push('Named drivers excluding Policyholder');
    }

    forEach(Object.keys(types), (type) => {
      if (!(disallowed).includes(type)) {
        limitedTypes.push(type);
      }
    });

    return Object.values(limitedTypes).map((type) => {
      return { label: type, value: type };
    });
  }

  private drivingRestrictionRules() {
    const { quote } = this.props;

    return get(quote, 'quotes.standard.annual.scheme.metadata.driving_restrictions', {});
  }

  private extendedUseTypes() {
    const { quote } = this.props;

    return get(quote, 'quotes.standard.annual.scheme.metadata.additional_use_types', {});
  }

  private mileageOptions() {
    const { quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.mileage', {});

    return Object.keys(types).map((type) => {
      return { label: type, value: type };
    });
  }

  private ownershipOptions() {
    const { quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.owner_types', {});

    return Object.keys(types).map((type) => {
      return { label: type, value: type };
    });
  }

  private trackerOptions() {
    const { quote } = this.props;

    const types = get(quote, 'quotes.standard.annual.scheme.metadata.trackers.horseboxes', {});

    return Object.keys(types).map((type) => {
      return { label: type, value: type };
    });
  }

  public render() {
    const {
      handleSubmit,
      vehicleCount,
      dispatch,
      change,
      quote,
      vehicles,
      renderDefinition,
    } = this.props;
    const { duplicateRegistration } = this.state;

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const hasBackButton = quote.application.status !== QuoteStatus.REFERRAL_APPROVED;
    const schemeId = quote.application.schemeId ? quote.application.schemeId :
      get(quote, 'quotes.standard.annual.scheme.id');

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <div className="sub-content-container">
            <FieldArray
              name="vehicles"
              component={Vehicles}
              count={vehicleCount}
              weightOptions={this.weightOptions()}
              coverOptions={this.coverOptions()}
              drivingRestrictionOptions={this.drivingRestrictionOptions()}
              drivingRestrictionRules={this.drivingRestrictionRules()}
              extendedUseTypes={this.extendedUseTypes()}
              mileageOptions={this.mileageOptions()}
              ownershipOptions={this.ownershipOptions()}
              trackerOptions={this.trackerOptions()}
              dispatch={dispatch}
              change={change}
              renderDefinition={renderDefinition}
              schemeId={schemeId}
              duplicateRegistration={duplicateRegistration}
            />
          </div>
          <NavigationBar
            hasBackButton={hasBackButton}
            backTo={'/proposer'}
            {...this.props}
            nextButtonDisabled={duplicateRegistration > -1}
            hasSaveButton={true}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const customerType = selector(state, 'customerType');
      const vehicleCount = selector(state, 'vehicleCount');
      const vehicles = selector(state, 'vehicles');

      return {
        startDate,
        quotationTypes,
        vehicleCount,
        customerType,
        vehicles,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(VehiclesForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/index.tsx